import { Star, ThumbDown, ThumbUp, ThumbUpSharp } from "@mui/icons-material";
import { BaseModuleSubtypeResponse } from "../../../../../../types/actionModule/baseModuleSubtype";
import { EvaluationThumbsSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/evaluationThumbsModels";

interface Props {
    subtype: BaseModuleSubtypeResponse;
    subtypeData: EvaluationThumbsSubtypeDataModel;
}

export default function EvaluationThumbsSubtypeDetails(props: Props) {
    return <>
        {
            props.subtypeData.answer === "ThumbsUp" && <ThumbUp color="success" />
        }
        {
            props.subtypeData.answer === "ThumbsDown" && <ThumbDown color="error" />
        }
    </>
}